module.exports = __webpack_public_path__ + "img/1548771092.7a067d5f.jpg";